import http from './request'

export function listContacts(params) {
  return http.get('/contacts', { params })
}

export function getCard(userId) {
  return http.get('/cards/' + userId)
}

export function getMyCard() {
  return http.get('/cards/mine')
}

export function saveMyCard(data) {
  return http.put('/cards/mine', data)
}

export function listIdentityTags() {
  return http.get('/identity-tags')
}
